import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const [isLogin, setIsLogin] = useState(Boolean(getSessionId()));


  function getSessionId() {
    const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
      const [name, value] = cookie.split('=');
      acc[name] = decodeURIComponent(value);
      return acc;
    }, {});
    return cookies.sessionid;
  }

  useEffect(() => {
    const interval = setInterval(() => {
     
      const sessionId = getSessionId();
      setIsLogin(Boolean(sessionId));
    }, 3000); 

    return () => clearInterval(interval);
  }, []);

  if (!isLogin) {
    return <Navigate to="/login" />;
  }


  return children;
};

export default ProtectedRoute;
